import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { IconRegistry } from './core/icon-registry';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    IconRegistry.registerIcon(this.iconRegistry, this.sanitizer);
  }
}
